<script lang="ts" setup>
  defineProps({
    order: { type: Object, required: true },
    payment: { type: Object, required: true },
    method: { type: Object, required: true },
  });
</script>
<template>
  <article class="bank-transfer">
    <header class="bank-transfer__header">
      <h2 class="bank-transfer__heading">{{ $t('SHOP.ORDER.HEADER.BANK_TRANSFER_DETAILS') }}</h2>
    </header>
    <section class="bank-transfer__details">
      <dl class="bank-transfer__list">
        <div class="bank-transfer__item bank-transfer__item-name">
          <dt class="bank-transfer__term bank-transfer__term-name">{{ $t('SHOP.ORDER.LABEL.BANK_TRANSFER_ACCOUNT_NAME') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-name">{{ method.props.account_name }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-account">
          <dt class="bank-transfer__term bank-transfer__term-account">{{ $t('SHOP.ORDER.LABEL.BANK_TRANSFER_ACCOUNT_NR') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-account">{{ method.props.account_nr }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item--address">
          <dt class="bank-transfer__term bank-transfer__term--address">{{ $t('SHOP.ORDER.LABEL.BANK_TRANSFER_ADDRESS') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details--address">{{ method.props.address }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-bank">
          <dt class="bank-transfer__term bank-transfer__term-bank">{{ $t('SHOP.ORDER.LABEL.BANK_TRANSFER_BANK') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-bank">{{ method.props.bank_name }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-id">
          <dt class="bank-transfer__term bank-transfer__term-id">{{ $t('SHOP.ORDER.LABEL.BANK_TRANSFER_TITLE') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-id">{{ order.number }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-total">
          <dt class="bank-transfer__term bank-transfer__term-total">{{ $t('SHOP.ORDER.LABEL.BANK_TRANSFER_AMOUNT') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-total">
            <SfMoney :code="order.currencyCode" :decimals="order.currencyDecimals" :value="order.totalGross" />
          </dd>
        </div>
      </dl>
    </section>
    <section class="bank-transfer__warning">
      <header class="bank-transfer__warning-header">
        <h3 class="bank-transfer__warning-heading">{{ $t('SHOP.ORDER.HEADER.BANK_TRANSFER_WARNING') }}</h3>
        <p class="bank-transfer__warning-text">{{ $t('SHOP.ORDER.MESSAGE.BANK_TRANSFER_WARNING') }}</p>
      </header>
    </section>
  </article>
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .bank-transfer {
    display: flex;
    flex-direction: column;
    margin: 2rem 0;
    gap: 1rem;

    &__term {
      font-weight: var(--font-weight-bold);
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    &__warning {
      margin-top: 2rem;
    }

    &__warning-text {
      font-size: 0.875rem

    }

    &__warning-heading {
      font-size: 1rem;
    }
  }

  @include media.query(lg) {

    .bank-transfer {
      &__heading {
        font-size: 1.25rem;
      }

      &__warning {
        margin-top: 1rem;
      }
    }
  }
</style>
